// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
const mc = require('__libs/ModuleConstructor.js');
mc.runVue(['Slider', 'Navigation', 'slickSlider','selectList']);
mc.runComponents(['rating']);
mc.runFooter();
const counter = require('__libs/counter.js');
counter.init();



// WEBPACK FOOTER //
// ./entries/product.js